import React from 'react';
import colors from 'constants/colors';

// It isn't a svg because the svg was 18px * 18px,
// and the line was occupying more space than needed
const SeparatorLine = ({ color = '$fmDefaultIcons' }) => {
    return (
        <div
            style={{
                height: '18px',
                width: '2px',
                backgroundColor: colors[color] ? colors[color] : '#E1E4E7',
            }}
        />
    );
};

export default SeparatorLine;
